module.exports = __webpack_public_path__ + "static/media/xVault.e2059c84.png";